import config from "../config";
import handleResponse from "./helper";


export const storageService = {
    getApplications,
    getPrimaries,
    getLevel2ForPrimary,
    getApplicationById,
    getPrimaryById
}
function getApplications(token) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/get-applications`, requestOptions).then(handleResponse);
}
function getApplicationById(token, id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/get-applications-by-id/${id}`, requestOptions).then(handleResponse);

}
function getPrimaries(token, application_id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/get-primary-for-application/${application_id}`, requestOptions).then(handleResponse);

}
function getPrimaryById(token, id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/get-primary-by-id/${id}`, requestOptions).then(handleResponse);
}
function getLevel2ForPrimary(token, primary_id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/get-level2-for-primary/${primary_id}`, requestOptions).then(handleResponse);
}
